module.exports = __webpack_public_path__ + "media/images/logo_mini-cc9c53d2.png";